import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home";
import About from "@/views/About";
import Options from "@/views/Options";
import Install from "@/views/Install";
import Installnode from "@/views/Installnode";
import Installc from "@/views/Installc";
import Installgo from "@/views/Installgo";
import Installvscode from "@/views/Installvscode";
import Installwails from "@/views/Installwails";
import Firsttest from "@/views/Firsttest";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/options",
    name: "Options",
    component: Options
  },
  {
    path: "/install",
    name: "Install",
    component: Install
  },
  {
    path: "/installnode",
    name: "Installnode",
    component: Installnode
  },
  {
    path: "/installc",
    name: "Installc",
    component: Installc
  },
  {
    path: "/installgo",
    name: "Installgo",
    component: Installgo
  },
  {
    path: "/installvscode",
    name: "Installvscode",
    component: Installvscode
  },
  {
    path: "/installwails",
    name: "Installwails",
    component: Installwails
  },
  {
    path: "/firsttest",
    name: "FirstTest",
    component: Firsttest
  }
];

const router = new VueRouter({
  routes,
  mode: "history"
});

export default router;
